import React, { useEffect, useState } from "react";
import { timesheetApi } from "../../../services";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { InputNumber } from "primereact/inputnumber";
import { toast } from "react-toastify";
import { useSelector } from 'react-redux';
import { selectUser } from '../../../services/store/userSlice';
function ConfigMapping() {
  const user = useSelector(selectUser);
  const empIndex = user.roles.indexOf('Masters Admin', 'Users Admin', 'ADMIN');
  const [configData, setConfigData] = useState([]);

  useEffect(() => {
    getAllConfigData();
  }, []);

  const getAllConfigData = () => {
    timesheetApi.getConfigurationSettingData().then((resp) => {
      setConfigData(resp.data.data);
    });
  };

  const onRowEditComplete = (e) => {
    const { newData } = e;
    const payload = {
      id: newData.id,
      title: newData.title,
      slug: newData.slug,
      value: newData.value
    };

    try {
      timesheetApi.updateConfigurationSettingData(payload).then((resp) => {
          toast.success('Configuration updated successfully');
          getAllConfigData();
        },
        (err) => {
          toast.error("Unable to update timesheet...");
        }
      );
    } catch (error) {
      toast.error("Unable to update timesheet...");
    }
  };

  const valueEditor = (options) => {
    return (
      <InputNumber
        value={options.value}
        onValueChange={(e) => options.editorCallback(e.value)}
      />
    );
  };

  const configActionBody = (rowData, rowIndex) => {
    return (
      <React.Fragment>
        <Button icon="pi pi-pencil" rounded text aria-label="Filter" />
      </React.Fragment>
    );
  };

  return (
    <React.Fragment>
      <DataTable dataKey="id" value={configData} editMode="row" onRowEditComplete={onRowEditComplete}>
        <Column field="title" header="Title" style={{ minWidth: "8rem" }} ></Column>
        <Column field="slug" header="Slug" style={{ minWidth: "9rem" }}></Column>
        <Column field="value" header="Value" style={{ minWidth: "9rem" }} editor={(options) => valueEditor(options)}></Column>
        <Column rowEditor headerStyle={{ width: '10%', minWidth: '8rem' }} bodyStyle={{ textAlign: 'center' }}></Column>
      </DataTable>
    </React.Fragment>
  );
}

export default ConfigMapping;
